// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0acb6076","513":"579f4d17","703":"482c9b2a","787":"d3befce1"}[chunkId] + ".chunk.js";
};